import type { EntityKind } from '../types/api'

/**
 * Who the Marketplace is offered to today.
 *
 * Students and guardians are off it for now. A flag rather than a deleted nav entry, because the
 * page, its route and everything behind it still work - this decides what is put in front of a
 * learner, not what exists. Turning it back on is emptying this list.
 *
 * It lives here rather than beside the navigation because the rail is not the only door: the
 * empty state of a learner's tutor recommendations offers the Marketplace too, and a rule kept in
 * one of those two places would leave the other one open. Anything that links to /marketplace
 * should ask this first.
 *
 * Note this is a display rule and not a gate: /marketplace is still routed and still loads for
 * anyone who types it, exactly as the hidden nav entries elsewhere in the app do.
 */
const MARKETPLACE_HIDDEN_FOR: EntityKind[] = ['STUDENT', 'GUARDIAN']

export function marketplaceHiddenFor(entityKind: EntityKind | null | undefined): boolean {
  return entityKind != null && MARKETPLACE_HIDDEN_FOR.includes(entityKind)
}
